import { isImmutableBeastModeError } from '@gonfalon/legacy-http-client/httpUtils';
import type { Middleware } from 'redux';

export const beastModeMiddleware: Middleware = () => (next) => (action) => {
  const finalAction = action;
  if (isImmutableBeastModeError(action.error)) {
    finalAction.error = null;
    finalAction.keepState = true;
  }
  next(finalAction);
};
